import { render, staticRenderFns } from "./AscMxRecSupportInfoWrapper.vue?vue&type=template&id=89fd994a&"
import script from "./AscMxRecSupportInfoWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecSupportInfoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecSupportInfoWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
